import React from "react";
import { Device } from "../../models/Device/types";
import { BlockProps } from "../../models/Global/types";
import { IProduct } from "../../models/Product/types";
import Block from "../Block";
import DeviceInfo from "./DeviceInfo";


function DeviceBlock({ data }: BlockProps<Device>) {
    const [open, setOpen] = React.useState<boolean>(false);

    function handleOpenModal() {
        setOpen(true);
    }

    function handleClose() {
        setOpen(false);
    }
    return <>
        <DeviceInfo
            open={open}
            // loading={getDevice.isLoading}
            data={data}
            handleClose={handleClose}
        />
        <Block data={data} handleOpenModal={setOpen}></Block>
    </>
}

export default DeviceBlock;